import React from "react";
import { defaultPageConfig, Page } from "/src/domain/shared/Page";
import '../../i18n';


import { mountComponentToContainer } from "/src/domain/shared/mountUtils";
import { AudiosApp } from "./AudiosApp";

window.mountPage = mountPage;

function mountPage(page: Page) {

    if (page !== Page.AUDIOS) {
        console.error('Unknown page type');
        return;
    }

    mountComponentToContainer(page, {}, undefined, defaultPageConfig, AudiosApp);
}

// mountPage(Page.AUDIOS);